import React from 'react';
import { Sidebar } from '@components/Shared/Sidebar';
import { LayoutContainer, MainContainer } from './Page.styles';

function Page({ children }) {
  return (
    <LayoutContainer>
      <Sidebar />
      <MainContainer>
        {children}
      </MainContainer>
    </LayoutContainer>
  );
}

export default Page;
